<template>
  <tr v-bind:class="{selected: selected}" v-on:click="onSelectionChanged">
    <td class="half-padding">
      <a-checkbox
          ref="checkbox"
          :checked="selected"
          @change="onSelectionChanged"
          v-on:click.stop
      ></a-checkbox>
    </td>
    <td>
      <div v-if="!editing">
        <a-tooltip placement="top">
          <template slot="title">
            <span>Onderwerp: {{ email.subject }}</span>
          </template>
          <a :href="emailShowUri" v-on:click.stop>{{ email.name }}</a>
          <attachment-icon v-if="email.has_attachment" style="cursor: pointer;"></attachment-icon>
          <span v-if="email.sent === 1"> (Verstuurd)</span>
        </a-tooltip>

        <pencil-icon style="cursor: pointer;" v-on:click.stop="onEditClick"></pencil-icon>
        <breadcrumbs v-if="hasCustomer" :attachableClass="email.morph_class"
                     :attachableId="email.id"></breadcrumbs>
        <br/>
      </div>
      <div v-if="editing">
        <a-input-group compact>
          <a-input ref="emailNameInput" :defaultValue="email.name" style="width: 80%;"
                   v-bind:disabled="updateNameLoading"
                   v-on:click.stop
                   v-on:keyup.enter="onSave" v-on:keyup.esc="onCancel"></a-input>
          <a-button :loading="updateNameLoading" v-on:click.stop="onSave">
            <content-save-icon></content-save-icon>
          </a-button>
        </a-input-group>
      </div>
      <small v-if="email.sent === 1">Aan: {{ email.to }}</small>
      <small>Van: {{ email.from }}</small>
    </td>
    <td>
      <CustomerBadgeComponent v-if="hasCustomer" :customer="email.customer.data"></CustomerBadgeComponent>
    </td>
    <td> {{ date }}</td>
    <td>
      <UserBadgeComponent v-if="hasProcessedBy" :user="email.processedBy.data"></UserBadgeComponent>
    </td>
    <td class="compact text-right">
      <a-button v-if="hasCustomer" :loading="unmatchLoading" type="danger" v-on:click.stop="onUnmatchClick">
        <link-variant-off-icon></link-variant-off-icon>
        Ontkoppel
      </a-button>

      <a-popconfirm v-if="hasCustomer" cancel-text="Nee" ok-text="Ja" placement="topRight"
                    @confirm="onUnprocessClick(true)" @cancel="onUnprocessClick(false)">
        <template slot="title">
          Wilt u een taak aanmaken?
        </template>
        <a-tooltip placement="left">
          <template slot="title">
            <span>Markeren als onverwerkt</span>
          </template>
          <a-button :loading="unprocessLoading" type="primary">
            <check-icon></check-icon>
          </a-button>
        </a-tooltip>
      </a-popconfirm>

      <a-tooltip v-if="!hasCustomer" placement="left">
        <template slot="title">
          <span>Markeren als onverwerkt</span>
        </template>
        <a-button :loading="unprocessLoading" type="primary" v-on:click.stop="onUnprocessClick(false)">
          <check-icon></check-icon>
        </a-button>
      </a-tooltip>

      <a-button v-if="!hasCustomer" v-on:click.stop="onMatchClick">
        <link-variant-icon></link-variant-icon>
        Koppelen
      </a-button>

    </td>
  </tr>
</template>

<script>
import {mapGetters} from "vuex";
import store from "../store";
import emailApi from "~/api/email";
import userApi from "~/api/user";
import CustomerBadgeComponent from "~/modules/customer/components/BadgeComponent";
import UserBadgeComponent from "~/modules/user/components/BadgeComponent";
import EmailStatusComponent from "~/modules/email/components/EmailStatusComponent";
import DateFormatEnum from "~/enums/DateFormatEnum";

const moment = require('moment');

export default {
  name: "ProcessedRowComponent",
  props: {
    email: {
      type: Object,
      required: true
    }
  },
  components: {CustomerBadgeComponent, UserBadgeComponent, EmailStatusComponent},
  data() {
    return {
      editing: false,
      updateNameLoading: false,
      unprocessLoading: false,
      unmatchLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      name: '$_email/name',
    }),
    emailShowUri() {
      return '/email/show/' + this.email.id
    },
    selected() {
      return store.state.selectedEmails.findIndex(x => x.id === this.email.id) >= 0;
    },
    hasCustomer() {
      return typeof this.email.customer_id !== "undefined" && this.email.customer_id !== null
          && typeof this.email.customer !== "undefined" && this.email.customer !== null;
    },
    hasProcessedBy() {
      return typeof this.email.processed_by_id === "number"
          && typeof this.email.processedBy !== "undefined" && this.email.processedBy !== null;
    },
    date() {
      return moment(this.email.date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATETIME);
    }
  },
  created() {
    const STORE_KEY = '$_email';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  methods: {
    onUnmatchClick() {
      this.unmatchLoading = true;
      emailApi.unmatchEmail(this.email.id).then(() => {
        this.email.customer_id = null;
        this.$emit('onUnmatched', this.email);
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de e-mail niet ontkoppelen',
        });
      }).finally(() => {
        this.unmatchLoading = false;
      })
    },
    processBadges(badge, count) {
      let $badge = $(badge);
      if (count === 0) {
        $badge.addClass('hidden');
      } else {
        $badge.removeClass('hidden').text(count);
      }
    },
    onUnprocessClick(createTask = false) {
      this.unprocessLoading = true;

      emailApi.unprocessEmail(this.email.id).then((response) => {
        this.$emit('onUnprocessed', this.email);
        // JS in stead of component
        response.data.emailAccounts.forEach((emailAccount) => {
          this.processBadges('.badge.email-account-count[data-id="' + emailAccount.email_account_hashid + '"]', emailAccount.count)
        });
        // Total
        this.processBadges('.emails-panel-count', response.meta.count);
        this.processBadges('.total-email-count', response.meta.count);

        if (this.hasCustomer && createTask) {
          this.navigator.openPath('/customer/' + this.email.customer_id + "/task/create/email/" + this.email.id);
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de e-mail niet verwerken',
        });
      }).finally(() => {
        this.unprocessLoading = false;
      })
    },
    onMatchClick() {
      window.location.href = '/email/unmatched/' + this.email.id;
    },
    onEditClick(e) {
      this.editing = true;
    },
    onSave() {
      this.updateEmailName();
    },
    onCancel() {
      this.editing = false;
      this.$refs.emailNameInput.stateValue = this.email.name;
    },
    updateEmailName() {
      if (this.email.name === this.$refs.emailNameInput.stateValue) {
        this.editing = false;
        return;
      }

      this.email.name = this.$refs.emailNameInput.stateValue;
      this.updateNameLoading = true;

      emailApi.updateEmail(this.email.id, {
        name: this.email.name,
      }).then(() => {

      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de gewijzigde naam van de e-mail niet opslaan',
        });
      }).finally(() => {
        this.editing = false;
        this.updateNameLoading = false;
      });
    },
    onSelectionChanged(e) {
      let shiftKey = false;

      if (typeof e.nativeEvent !== "undefined") {
        shiftKey = e.nativeEvent.shiftKey;
      }

      this.$emit('onSelectionChanged', this.email, !this.selected, shiftKey);
    },
  }
}
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}
</style>
